import { render, staticRenderFns } from "./ztsz-qwsy.vue?vue&type=template&id=3dbfea9e&"
import script from "./ztsz-qwsy.vue?vue&type=script&lang=js&"
export * from "./ztsz-qwsy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports